/*! Michael Pumo - helpers.js */

function domReady (fn) {
  console.log(document.readyState)

  if (document.readyState !== 'loading') {
    fn()
    return
  }

  document.addEventListener('DOMContentLoaded', fn)
}

function randomNumber (from, to) {
  return Math.floor(Math.random() * to) + from
}

export {
  randomNumber,
  domReady
}
